import React from 'react';

interface Props {
    status: number;
    showName?: boolean;
    statusList: StatusColor;
}

export interface StatusDetails {
    description: string;
    color: string;
    id: number;
}

export interface StatusColor {
    [status: string]: StatusDetails;
}

export const StatusIndicator = ({ status, statusList, showName = false }: Props) => {
    const currentStatus = Object.entries(statusList).find(
        (item) => item[1].id == status
    )?.[1];

    const dotStyle: React.CSSProperties = {
        width: '15px',
        height: '15px',
        borderRadius: '50%',
        backgroundColor: currentStatus?.color,
        display: 'inline-block',
    };

    return !showName ? (
        <div
            title={currentStatus?.description}
            className='d-flex align-items-center'
        >
            <span style={dotStyle} />
        </div>
    ) : (
        <span
            hidden={!currentStatus}
            className={`badge text-center`}
            style={{
                backgroundColor: currentStatus?.color,
            }}
        >
            {currentStatus?.description}
        </span>
    );
};
